import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Dashboard } from "@/services/cloudchipr.api";
import { DashboardFolderWithChildren } from "@/components/pages/dashboard-all-items/components/table/utils/types/types";
import { isHierarchyFolder } from "@/store/navigation/utils/helpers/isHierarchyFolder";
import { DashboardV2FolderActionButton } from "@/components/app-navigation/components/page-components/dashboard/components/folder-actions-menu/DashboardV2FolderActionButton";
import { DashboardV2ItemActionButton } from "@/components/app-navigation/components/page-components/dashboard/components/item-actions-menu/DashboardV2ItemActionButton";
import { hierarchyFolderNoItemsText } from "@/store/common/utils/helpers/getHierarchyAllItemsFolderChildren";

export const DashboardAllItemsActionCellRenderer: FC<
  CustomCellRendererProps<Dashboard | DashboardFolderWithChildren>
> = ({ data, node }) => {
  if (!data || data?.name === hierarchyFolderNoItemsText || node.footer) {
    return null;
  }

  if (isHierarchyFolder(data)) {
    return (
      <DashboardV2FolderActionButton
        size="medium"
        id={data.id}
        name={data.name}
        redirectAfterCreate={false}
        visibility={data.visibility}
        containsProtectedItem={data.items?.some(
          (item) => item.protection_details?.is_protected,
        )}
      />
    );
  }

  return (
    <DashboardV2ItemActionButton
      size="medium"
      id={data.id}
      name={data.name}
      visibility={data.visibility}
      protectionDetails={data.protection_details}
      protectedBy={data.protected_by}
    />
  );
};
